"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCallbacksForSave = void 0;
var _reactRedux = require("react-redux");
var _actions = require("../../../modalDispatcher/store/actions");
var _actions2 = require("./store/actions");
var _constants = require("./constants");
var useCallbacksForSave = exports.useCallbacksForSave = function useCallbacksForSave(indicatorsKey) {
  var dispatch = (0, _reactRedux.useDispatch)();
  return {
    onCloseModal: function onCloseModal() {
      dispatch((0, _actions.close)(_constants.SAVE_TO_CLAIM_MODAL_KEY));
      dispatch((0, _actions.destroy)(_constants.SAVE_TO_CLAIM_MODAL_KEY));
    },
    onStart: function onStart() {
      return dispatch((0, _actions2.startSavingClaim)(indicatorsKey));
    },
    onSuccess: function onSuccess() {
      return dispatch((0, _actions2.successSavingClaim)(indicatorsKey));
    },
    onFail: function onFail(error) {
      return dispatch((0, _actions2.failSavingClaim)(indicatorsKey, error));
    },
    onFinish: function onFinish() {
      return dispatch((0, _actions2.finishSavingClaim)(indicatorsKey));
    }
  };
};